import { Component, Input } from '@angular/core';
import { RememberService } from '@app/core/services/remember.service';
import { CustactGet } from '@app/services/custact.service';

@Component({
    selector: 'tt-work-details-plans-functions',
    templateUrl: './work-details-plans-functions.component.html',
    styleUrls: ['./work-details-plans-functions.component.css'],
})
export class WorkDetailsPlansFunctionsComponent {
    @Input()
    public params?: CustactGet;

    constructor(private remember: RememberService) {}

    public rememberCustactLink = async () => {
        if (!!this.params) {
            await this.remember.remember('custact_no_linkto', this.params.custact_no);
        }
    };
}
